import { forwardRef } from 'react';
import type React from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const Close = styled.svg.attrs({ className: 'h-16 w-16' })`
  path {
    stroke: var(--cvna-color-grey-3);
  }

  &:hover {
    path {
      stroke: var(--cvna-color-blue-6);
    }
  }
`;

const CloseIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <Close
    viewBox="0 0 16 16"
    fill="none"
    ref={ref}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 4L4 12" strokeLinecap="round" />
    <path d="M12 12L4 4" strokeLinecap="round" />
  </Close>
));

export default CloseIcon;
